<template>
    <div>
        <b-form @submit.prevent>
            <b-row>
                <!-- Hücre Kodu -->
                <b-col md="6">
                    <b-form-group label="Hücre Kodu" label-for="cell-code">
                        <b-form-input id="cell-code" v-model="form.CellCode" placeholder="Hücre kodu giriniz" :disabled="isEditing" />
                    </b-form-group>
                </b-col>

                <!-- Hücre Adı -->
                <b-col md="6">
                    <b-form-group label="Hücre Adı" label-for="cell-name">
                        <b-form-input id="cell-name" v-model="form.CellName" placeholder="Hücre adı giriniz" />
                    </b-form-group>
                </b-col>

                <!-- Depo Kodu -->
                <b-col md="6">
                    <b-form-group label="Depo Kodu" label-for="warehouse-code">
                        <b-form-input id="warehouse-code" v-model.number="form.WarehouseCode" type="number" placeholder="Depo kodu giriniz" />
                    </b-form-group>
                </b-col>

                <!-- Açıklama -->
                <b-col md="12">
                    <b-form-group label="Açıklama" label-for="description">
                        <b-form-textarea id="description" v-model="form.Description" rows="3" />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
import { BForm, BRow, BCol, BFormGroup, BFormInput, BFormTextarea } from "bootstrap-vue";

export default {
    name: "CellCreateOrUpdate",
    components: {
        BForm,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        isEditing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {},
            isInternalUpdate: false,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue, oldValue) {
                if (newValue.Id !== (oldValue ? oldValue.Id : null)) {
                    this.isInternalUpdate = true;
                    this.form = { ...newValue };
                    this.$nextTick(() => {
                        this.isInternalUpdate = false;
                    });
                }
            },
        },
        form: {
            deep: true,
            handler(newForm) {
                if (!this.isInternalUpdate) {
                    this.$emit("input", newForm);
                }
            },
        },
    },
};
</script>
